export default function NoCostIcon(props) {
    const { style, ...rest } = props

    return (
        <svg
            width='21'
            height='20'
            viewBox='0 0 21 20'
            xmlns='http://www.w3.org/2000/svg'
            style={style}
            {...rest}
            fill='none'
        >
            <g clip-path='url(#clip0_118_17840)'>
                <path
                    d='M4.00006 5.8335H9.00006'
                    stroke='currentColor'
                    stroke-opacity='0.88'
                    stroke-width='1.6'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M6.50006 3.3335V8.3335'
                    stroke='currentColor'
                    stroke-opacity='0.88'
                    stroke-width='1.6'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M17.3334 13.3335H12.3334'
                    stroke='currentColor'
                    stroke-opacity='0.88'
                    stroke-width='1.6'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M17.3334 15.8335H12.3334'
                    stroke='currentColor'
                    stroke-opacity='0.88'
                    stroke-width='1.6'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
                <path
                    d='M4.83337 15.8332L16.5 4.1665'
                    stroke='currentColor'
                    stroke-opacity='0.88'
                    stroke-width='1.6'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                />
            </g>
            <defs>
                <clipPath id='clip0_118_17840'>
                    <rect width='20' height='20' fill='white' transform='translate(0.666718)' />
                </clipPath>
            </defs>
        </svg>
    )
}
